export default __webpack_public_path__ + "static/media/pintrest.5319a3e6.svg";